<template>
	<div class="home-container">
		<div class="operateInfo" v-show="permission.isTotal">
			<div class="modal-title" style="border-bottom: 1px solid #e8eaec;">
				<div class="layout-title-left">
					<img src='/static/imgs/jingyingqingkuang.png' class="jxyd-imgicon"/>
					经营情况
				</div>
				<div class="layout-title-right">
					<ul class="title-right-ul">
						<li @click="totalClickNode" class="total-ul_selected">昨日</li>
						<li @click="totalClickNode">今日</li>
						<li @click="totalClickNode">本周</li>
						<li @click="totalClickNode">本月</li>
						<li @click="totalClickNode">本季</li>
						<li @click="totalClickNode">本年</li>
						<li @click="totalClickNode">全部</li>
						<li>
							<DatePicker ref="totalDate" type="daterange" show-week-numbers placement="bottom-end"
								placeholder="请选择日期" @on-change="totalDateChange" style="width: 200px" :transfer='true'>
							</DatePicker>
						</li>
					</ul>
				</div>
			</div>
			<div style="padding:10px">
				<Row :gutter="16">
					<Col :lg="4" :md="8" :xs="24">
					<Card style="padding:20px;background-color: rgb(234, 245, 255);">
						<div>
							销售金额（元）
							<Tooltip :max-width="500" content="销售金额=销售单+零售单+其它收款单">
								<Icon type="ios-help-circle-outline" size='18'/>
							</Tooltip>
						</div>
						<div class="number-style" @click="clickTotalLists('销售金额',1)">
							{{operateData.totalAmount.salesAmount}}</div>
					</Card>
					</Col>
					<Col :lg="4" :md="8" :xs="24">
					<Card style="padding:20px;background-color: rgb(256, 241, 322);">
						<div>
							销售成本（元）
							<Tooltip :max-width="500" content="销售成本=零售单+销售单+其它付款单">
								<Icon type="ios-help-circle-outline" size='18'/>
							</Tooltip>
						</div>
						<div class="number-style" @click="clickTotalLists('销售成本',1)">
							{{operateData.totalAmount.salesCost}}</div>
					</Card>
					</Col>
					<Col :lg="4" :md="8" :xs="24">
					<Card style="padding:20px;background-color: rgb(200, 300, 230);">
						<div>
							销售利润（元）
							<Tooltip :max-width="500" content="销售利润=零售单+销售单+其它收款单-销售成本">
								<Icon type="ios-help-circle-outline" size='18'/>
							</Tooltip>
						</div>
						<div class="number-style" @click="clickTotalLists('销售利润',1)">
							{{operateData.totalAmount.salesProfit}}</div>
					</Card>
					</Col>
					<Col :lg="4" :md="8" :xs="24">
					<Card style="padding:20px;background-color: rgb(231, 248, 251);">
						<div>
							退货金额（元）
							<Tooltip content="退货金额=销售退货单">
								<Icon type="ios-help-circle-outline" size='18'/>
							</Tooltip>
						</div>
						<div class="number-style" @click="clickTotalLists('退货金额',1)">
							{{operateData.totalAmount.returnAmount}}</div>
					</Card>
					</Col>
					<Col :lg="4" :md="8" :xs="24">
					<Card style="padding:20px;background-color: rgb(254, 244, 237);">
						<div>
							收款金额（元）
							<Tooltip :max-width="500" content="收款金额=销售单付款金额+零售单付款金额+关联收款单金额+采购退货单金额+其它收款单金额">
								<Icon type="ios-help-circle-outline" size='18'/>
							</Tooltip>
						</div>
						<div class="number-style" @click="clickTotalLists('收款金额',1)">
							{{operateData.totalAmount.receiptAmount}}</div>
					</Card>
					</Col>
					<Col :lg="4" :md="8" :xs="24">
					<Card style="padding:20px;background-color: rgb(255, 255, 242);">
						<div>
							付款金额（元）
							<Tooltip :max-width="500" content="付款金额=采购单付款金额+关联付款单金额+销售退货单金额+其它付款单金额"
								style="cursor: pointer;">
								<Icon type="ios-help-circle-outline" size='18'/>
							</Tooltip>
						</div>
						<div class="number-style" @click="clickTotalLists('付款金额',1)">
							{{operateData.totalAmount.paymentAmount}}</div>
					</Card>
					</Col>
				</Row>
			</div>
		</div>
		<div class="operateInfo" v-show="permission.isTrend">
			<div class="modal-title" style="border-bottom: 1px solid #e8eaec;">
				<div class="layout-title-left">
					<img src='/static/imgs/jingyingqushi.png' class="jxyd-imgicon"/>
					经营趋势
				</div>
				<div class="layout-title-right">
					<ul class="title-right-ul">
						<li @click="trendClickNode">昨日</li>
						<li @click="trendClickNode">今日</li>
						<li @click="trendClickNode" class="trend-ul_selected">本周</li>
						<li @click="trendClickNode">本月</li>
						<li @click="trendClickNode">本季</li>
						<li @click="trendClickNode">本年</li>
						<li>
							<DatePicker ref="trendDate" type="daterange" show-week-numbers placement="bottom-end"
								placeholder="请选择日期" @on-change="trendDateChange" style="width: 200px" :transfer='true'>
							</DatePicker>
						</li>
					</ul>
				</div>
			</div>
			<div id="trendChart"></div>
		</div>
		<div class="operateInfo">
			<div class="modal-title" style="border-bottom: 1px solid #e8eaec;">
				<div class="layout-title-left">
					<img src='/static/imgs/kuaijiecaozuo.png' class="jxyd-imgicon"/>
					快捷操作
				</div>
				<div class="layout-title-right">
				</div>
			</div>
			<div style="padding:10px;">
				<Row :gutter="16">
					<Col :lg="6">
					<Card class="card-box" style="background-color: #f0faff;border: 1px solid #2d8cf0;">
						<div>
							<img src='/static/imgs/daishenhe.png' class="jxyd-imgicon"/>
							待审核
							<Tooltip :max-width="500" content="所有待审核的单据">
								<Icon type="ios-help-circle-outline" size='18' />
							</Tooltip>
						</div>
						<div class="number-style" @click="goDetailPage('auditlist')">
							{{flowListCount}}</div>
					</Card>
					</Col>
					<Col :lg="6">
					<Card class="card-box" style="background-color: #fff5f5;border: 1px solid #fa795e;">
						<div>
							<img src='/static/imgs/jingyingfenxi.png' class="jxyd-imgicon"/>
							经营分析
							<Tooltip :max-width="500" content="对经营数据的对比分析">
								<Icon type="ios-help-circle-outline" size='18'/>
							</Tooltip>
						</div>
						<div style="height: 45px;" @click="goDetailPage('BusinessAnalysis')"></div>
					</Card>
					</Col>
					<Col :lg="6">
					<Card class="card-box" style="background-color: white;border: 1px solid #f90;">
						<div>
							<img src='/static/imgs/qianbao.png' class="jxyd-imgicon"/>
							待收款
							<Tooltip :max-width="500" content="所有待收款的单据">
								<Icon type="ios-help-circle-outline" size='18'/>
							</Tooltip>
						</div>
						<div class="number-style" @click="goDetailPage('UncollectedList')">
							{{uncollectedListCount}}</div>
					</Card>
					</Col>
					<Col :lg="6">
					<Card class="card-box" style="background-color:white;border: 1px solid #F69;">
						<div>
							<img src='/static/imgs/zhifu.png' class="jxyd-imgicon"/>
							待付款
							<Tooltip content="所有待付款的单据">
								<Icon type="ios-help-circle-outline" size='18'/>
							</Tooltip>
						</div>
						<div class="number-style" @click="goDetailPage('UnpaidList')">
							{{unpaidListCount}}</div>
					</Card>
					</Col>
				</Row>
			</div>
		</div>
		<Row :gutter="16">
			<Col :lg="12" :md="24" :xs="24" v-if="permission.isReceivables || permission.isDebt">
			<div class="operateInfo" style="margin-bottom:0px;">
				<div class="modal-title" style="border-bottom: 1px solid #e8eaec;">
					<div class="layout-title-left">
						<img src='/static/imgs/paihang.png' class="jxyd-imgicon"/>
						欠款排行
					</div>
					<div class="layout-title-right">
					</div>
				</div>
				<div style="overflow:auto;padding:10px;height:500px;">
					<RadioGroup v-model="debtList" type="button" style="margin:20px 10px;">
						<Radio label="receipt" v-if="permission.isReceivables">应收欠款</Radio>
						<Radio label="payment" v-if="permission.isDebt">应付欠款</Radio>
					</RadioGroup>

					<span style="font-size:16px;float:right;margin:20px 10px;">
						欠款总额：
						<span style="color:#00c5ab;">
							{{debtAmount}}
						</span>
					</span>
					<Table stripe :columns="debtListColumn" :data="debtListData"></Table>
				</div>
			</div>
			</Col>
			<Col :lg="12" :md="24" :xs="24" v-if="permission.isStockAlarm || permission.isOverdueAlarm">
			<div class="operateInfo" style="margin-bottom: 0px;">
				<div class="modal-title" style="border-bottom: 1px solid #e8eaec;">
					<div class="layout-title-left">
						<img src='/static/imgs/paihang.png' class="jxyd-imgicon"/>
						库存报警/超期商品排行
					</div>
					<div class="layout-title-right">
					</div>
				</div>
				<div style="overflow:auto;padding:10px;height:500px;">
					<RadioGroup v-model="alarmList" type="button" style="margin:20px 10px;">
						<Radio label="stock" v-if="permission.isStockAlarm">库存报警</Radio>
						<Radio label="overdue" v-if="permission.isOverdueAlarm">超期商品</Radio>
					</RadioGroup>

					<span style="font-size:16px;float:right;margin:20px 10px;">
						报警数量：
						<span style="color:#00c5ab;">
							{{alarmCount}}
						</span>
					</span>
					<Table stripe :columns="alarmListColumn" :data="alarmListData"></Table>
				</div>
			</div>
			</Col>
		</Row>

		<Modal v-model="totalDetailModal" draggable sticky scrollable 
		:width="1500" :styles="{top: '20px'}">
			<p slot="header" class="modal-header">
				<img src='/static/imgs/danju.png' class="jxyd-imgicon"/>
				<span style="float: left;margin-left:10px;">{{totalDetailModalTitle}}</span>
			</p>
			<div style="background-color:#fff;border-radius:5px;padding:20px;">
				<div id="box-search">
					<Form ref="formSearch" :label-width="100" :model="searchItems" inline>
						<Row :gutter="16">
							<Col :lg="8" :md="24">
							<FormItem label="单据编号" style="width:100%">
								<Input type="text" v-model="searchItems.listCode" placeholder="请输入单据编号"
									@keyup.enter.native="clickTotalLists(totalDetailModalTitle,1)" />
							</FormItem>
							</Col>
							<Col :lg="8" :md="24">
							<FormItem label="操作员" style="width:100%">
								<Input type="text" v-model="searchItems.userName" placeholder="请输入操作员"
									@keyup.enter.native="clickTotalLists(totalDetailModalTitle,1)" />
							</FormItem>
							</Col>
							<Col :lg="8" :md="24">
							<FormItem label="业务方" style="width:100%">
								<Input type="text" v-model="searchItems.businessPeopleName" placeholder="请输入业务方"
									@keyup.enter.native="clickTotalLists(totalDetailModalTitle,1)" />
							</FormItem>
							</Col>

						</Row>
						<Row :gutter="16" v-show="totalDetailModalAdvancedSelect">
							<Col :lg="8" :md="24">
							<FormItem label="单据状态" style="width:100%">
								<Select v-model="searchItems.checkState"
									@on-change="clickTotalLists(totalDetailModalTitle,1)">
									<Option :value="-1" :key="-1">请选择</Option>
									<!--<Option :value="1" :key="1">已创建</Option>-->
									<Option :value="2" :key="2">已过账</Option>
									<Option :value="3" :key="3">已完结</Option>
								</Select>
							</FormItem>
							</Col>
							<Col :lg="8" :md="24">
							<FormItem label="单据类型" style="width:100%">
								<Select v-model="searchItems.listType"
									@on-change="clickTotalLists(totalDetailModalTitle,1)">
									<Option value="请选择" key="1">请选择</Option>
									<Option value="采购单" key="2">采购单</Option>
									<Option value="采购退货单" key="3">采购退货单</Option>
									<Option value="其它付款单" key="4">其它付款单</Option>
									<Option value="零售单" key="5">零售单</Option>
									<Option value="销售单" key="6">销售单</Option>
									<Option value="销售退货单" key="7">销售退货单</Option>
									<Option value="付款单" key="8">付款单</Option>
									<Option value="收款单" key="9">收款单</Option>
								</Select>
							</FormItem>
							</Col>
							<Col :lg="8" :md="24">
							<FormItem label="单据备注" style="width:100%">
								<Input type="text" v-model="searchItems.note" placeholder="请输入备注"
									@keyup.enter.native="clickTotalLists(totalDetailModalTitle,1)" />
							</FormItem>
							</Col>
						</Row>
						<FormItem :label-width="20">
							<Button type="primary" @click="clickTotalLists(totalDetailModalTitle,1)"
								style="margin-right:10px;">查询</Button>
							<Button @click="initTotalDetailModalSearch" style="margin-right:10px;">重置</Button>
							<span @click="totalDetailModalAdvancedSelect = true;" style="color:red;cursor: pointer;"
								v-if="!totalDetailModalAdvancedSelect">
								展开
								<Icon type="ios-arrow-down" size='18'/>
							</span>
							<span @click="foldTotalDetailModalSearch" style="color:red;cursor: pointer;" v-else>
								折叠
								<Icon type="ios-arrow-up" size='18'/>
							</span>
						</FormItem>
					</Form>
				</div>
				<Table stripe :columns="totalDetailModalColumn" :data="totalDetailModalListData"></Table>
				<div class="page-box">
					<Page :total="totalDetailModalListCount" :page-size="searchItems.pageSize"
						@on-change="clickTotalLists(totalDetailModalTitle,1)" show-total
						:current="searchItems.pageIndex" style="display:inline-block;">
					</Page>
				</div>
			</div>

			<div slot="footer">
				<Button type="primary" @click="totalDetailModal = false">关闭</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import formatDate from '@/utils/formatDate'
	import currentDate from '@/utils/currentDate'
	import dateUtil from '@/utils/dateUtil'
	import echarts from '@/utils/echarts'

	export default {
		name: 'home',
		components: {},
		data() {
			return {
				searchItems: {
					totalBusinessDate: [],
					trendBusinessDate: [],
					listCode: '',
					userName: '',
					businessPeopleName: '',
					listType: '',
					checkState: -1,
					note: '',
					pageSize: 10,
					pageIndex: 1
				},
				operateData: {
					totalAmount: {
						salesAmount: 0,
						returnAmount: 0,
						receiptAmount: 0,
						paymentAmount: 0,
						salesCost: 0,
						salesProfit: 0
					},
					trendInfos: []
				},
				totalDetailModal: false,
				totalDetailModalTitle: '',
				totalDetailModalListData: [],
				totalDetailModalListCount: 0,
				totalDetailModalAdvancedSelect: false,
				totalDetailModalColumn: [{
						title: '单据编号',
						key: 'code',
						width: 210
					},
					{
						title: '单据类型',
						key: 'listType',
						width: 200,
					},
					{
						title: '业务日期',
						key: 'businessDate',
						width: 150,
						render: (h, params) => {
							return h('span', {}, formatDate(new Date(params.row.businessDate), 'yyyy-MM-dd'));
						}
					},
					{
						title: '业务方',
						key: 'businessPeopleName',
						width: 200,
					},
					{
						title: '业务员',
						key: 'userDisplayName',
						width: 120,
					},
					{
						title: '单据状态',
						key: 'checkState',
						width: 120,
						render: (h, params) => {
							switch (params.row.checkState) {
								case 1:
									return h('Tag', {
										style: {},
										attrs: {
											color: 'magenta'
										}
									}, '已创建');
								case 2:
									return h('Tag', {
										style: {},
										attrs: {
											color: 'red'
										}
									}, '已过账');
								case 3:
									return h('Tag', {
										style: {},
										attrs: {
											color: 'success'
										}
									}, '已完结');
							}
						}
					},
					{
						title: '支付方式',
						key: 'payway',
						width: 150
					},
					{
						title: '金额',
						key: 'amount',
						width: 150
					},
					{
						title: '支付金额',
						key: 'payAmount',
						width: 150
					},
					{
						title: '备注',
						key: 'note',
						width: 400
					},
					//{
					//    title: '操作',
					//    key: 'action',
					//    width: 200,
					//    align: 'center',
					//    fixed: 'right',
					//    render: (h, params) => {
					//        return h('Button', {
					//            props: {
					//                type: 'dashed'
					//            },
					//            style: {
					//                'margin-right': 10
					//            },
					//            on: {
					//                click: (val) => {
					//                }
					//            }
					//        }, [h('svg', {
					//            class: 'icon',
					//        }, [h('use', {
					//            attrs: {
					//                'xlink:href': '#icon-chakan2'
					//            }
					//        })])]);
					//    }
					//}
				],
				debtList: '',
				debtAmount: 0,
				debtListColumn: [{
						title: '排行',
						key: 'num',
						width: 100,
					},
					{
						title: '名称',
						key: 'name'
					},
					{
						title: '欠款(元)',
						key: 'debt',
						width: 150
					}
				],
				debtListData: [],
				alarmList: 'stock',
				alarmCount: 0,
				alarmListColumn: [{
						title: '排行',
						key: 'num',
						width: 100,
					},
					{
						title: '名称',
						key: 'name'
					},
					{
						title: '规格',
						key: 'format'
					},
					{
						title: '超期时间',
						key: 'validityPeriod',
						render: (h, params) => {
							return h('span', {}, params.row.validityPeriod ? formatDate(new Date(params.row
								.validityPeriod), 'yyyy-MM-dd') : '');
						}
					},
					{
						title: '库存',
						key: 'stock',
						width: 150
					}
				],
				alarmListData: [],
				permission: {
					isTotal: false,
					isTrend: false,
					isReceivables: false,
					isDebt: false,
					isStockAlarm: false,
					isOverdueAlarm: false
				},
				flowListCount: 0,
				unpaidListCount: 0,
				uncollectedListCount: 0
			}
		},
		methods: {
			totalClickNode(node) {
				if (this.$refs.totalDate.visualValue) {
					this.$refs.totalDate.handleClear();
				}
				var array = node.currentTarget.parentElement.childNodes;
				for (var i = 0; i < array.length; i++) {
					array[i].className = '';
				}
				node.currentTarget.className = 'total-ul_selected';
				this.getTotalOperate(node.currentTarget.innerHTML);
			},
			getTotalOperate(innerHtml) {
				let self = this;
				switch (innerHtml) {
					case '全部':
						self.searchItems.totalBusinessDate = [];
						break;
					case '昨日':
						self.searchItems.totalBusinessDate = [];
						self.searchItems.totalBusinessDate.push(dateUtil.startTime(dateUtil.getYesterday()));
						self.searchItems.totalBusinessDate.push(dateUtil.endTime(dateUtil.getYesterday()));
						break;
					case '今日':
						self.searchItems.totalBusinessDate = [];
						self.searchItems.totalBusinessDate.push(dateUtil.startTime(dateUtil.getBeginToday()));
						self.searchItems.totalBusinessDate.push(dateUtil.endTime(dateUtil.getBeginToday()));
						break;
					case '本周':
						self.searchItems.totalBusinessDate = [];
						self.searchItems.totalBusinessDate.push(dateUtil.getBeginWeek());
						self.searchItems.totalBusinessDate.push(dateUtil.getEndWeek());
						break;
					case '本月':
						self.searchItems.totalBusinessDate = [];
						self.searchItems.totalBusinessDate.push(dateUtil.getBeginMonth());
						self.searchItems.totalBusinessDate.push(dateUtil.getEndMonth());
						break;
					case '本季':
						self.searchItems.totalBusinessDate = [];
						self.searchItems.totalBusinessDate.push(dateUtil.getCurrentQuarterStartDate());
						self.searchItems.totalBusinessDate.push(dateUtil.getCurrentQuarterEndDate());
						break;
					case '本年':
						self.searchItems.totalBusinessDate = [];
						self.searchItems.totalBusinessDate.push(dateUtil.getCurrentYearStartDate());
						self.searchItems.totalBusinessDate.push(dateUtil.getCurrentYearEndDate());
						break;
					default:
						break;
				}
				request.post('/api/Home/GetTotalOperate', self.searchItems).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取经营情况数据失败：" + response.errorMsg
						});
						return;
					}
					self.operateData.totalAmount = response.data;
				}).catch(function(error) {})
			},
			totalDateChange(val) {
				if (val[0]) {
					this.searchItems.totalBusinessDate = val;
				} else {
					this.searchItems.totalBusinessDate = [];
					return;
				}

				var selectedNodes = document.getElementsByClassName('total-ul_selected');
				if (selectedNodes.length > 0) {
					selectedNodes[0].className = '';
				}

				this.getTotalOperate('日期');
			},
			trendDateChange(val) {
				if (val[0]) {
					this.searchItems.trendBusinessDate = val;
				} else {
					this.searchItems.trendBusinessDate = [];
					return;
				}

				var selectedNodes = document.getElementsByClassName('trend-ul_selected');
				if (selectedNodes.length > 0) {
					selectedNodes[0].className = '';
				}
				this.initTrendChart("");
			},
			trendClickNode(node) {
				if (this.$refs.trendDate.visualValue) {
					this.$refs.trendDate.handleClear();
				}
				var array = node.currentTarget.parentElement.childNodes;
				for (var i = 0; i < array.length; i++) {
					array[i].className = '';
				}
				node.currentTarget.className = 'trend-ul_selected';
				this.initTrendChart(node.currentTarget.innerHTML);
			},
			initTrendChart(innerHtml) {
				let self = this;
				let columns = [];
				switch (innerHtml) {
					case '全部':
						self.searchItems = {
							trendBusinessDate: []
						};
						break;
					case '昨日':
						self.searchItems.trendBusinessDate = [];
						self.searchItems.trendBusinessDate.push(dateUtil.startTime(dateUtil.getYesterday()));
						self.searchItems.trendBusinessDate.push(dateUtil.endTime(dateUtil.getYesterday()));
						columns = dateUtil.getLevelDate(self.searchItems.trendBusinessDate[0], self.searchItems
							.trendBusinessDate[1]);
						break;
					case '今日':
						self.searchItems.trendBusinessDate = [];
						self.searchItems.trendBusinessDate.push(dateUtil.startTime(dateUtil.getBeginToday()));
						self.searchItems.trendBusinessDate.push(dateUtil.endTime(dateUtil.getBeginToday()));
						columns = dateUtil.getLevelDate(self.searchItems.trendBusinessDate[0], self.searchItems
							.trendBusinessDate[1]);
						break;
					case '本周':
						self.searchItems.trendBusinessDate = [];
						self.searchItems.trendBusinessDate.push(dateUtil.getBeginWeek());
						self.searchItems.trendBusinessDate.push(dateUtil.getEndWeek());
						columns = dateUtil.getLevelDate(self.searchItems.trendBusinessDate[0], self.searchItems
							.trendBusinessDate[1]);
						break;
					case '本月':
						self.searchItems.trendBusinessDate = [];
						self.searchItems.trendBusinessDate.push(dateUtil.getBeginMonth());
						self.searchItems.trendBusinessDate.push(dateUtil.getEndMonth());
						columns = dateUtil.getLevelDate(self.searchItems.trendBusinessDate[0], self.searchItems
							.trendBusinessDate[1]);
						break;
					case '本季':
						self.searchItems.trendBusinessDate = [];
						self.searchItems.trendBusinessDate.push(dateUtil.getCurrentQuarterStartDate());
						self.searchItems.trendBusinessDate.push(dateUtil.getCurrentQuarterEndDate());
						columns = dateUtil.getLevelDate(self.searchItems.trendBusinessDate[0], self.searchItems
							.trendBusinessDate[1]);
						break;
					case '本年':
						self.searchItems.trendBusinessDate = [];
						self.searchItems.trendBusinessDate.push(dateUtil.getCurrentYearStartDate());
						self.searchItems.trendBusinessDate.push(dateUtil.getCurrentYearEndDate());
						columns = dateUtil.getLevelDate(self.searchItems.trendBusinessDate[0], self.searchItems
							.trendBusinessDate[1]);
						break;
					default:
						columns = dateUtil.getLevelDate(self.searchItems.trendBusinessDate[0], self.searchItems
							.trendBusinessDate[1]);
						break;
				}

				request.post('/api/Home/GetTrendOperate', self.searchItems).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取经营趋势数据失败：" + response.errorMsg
						});
						return;
					}
					echarts.dispose(document.getElementById("trendChart"));
					//self.operateData.trendInfos = response.data;
					const chartBox = echarts.init(document.getElementById("trendChart"));
					// 设置配置项
					const option = {
						xAxis: {
							data: columns,
						},
						yAxis: {},
						legend: {
							type: 'plain',
							top: 'bottom',
							data: ['销售金额', '销售成本', '销售利润', '退货金额', '收款金额', '付款金额'],
						},
						grid: {
							left: '3%',
							right: '4%',
							bottom: '6%',
							containLabel: true
						},
						series: [],
						tooltip: { // 鼠标悬浮提示框显示 X和Y 轴数据
							trigger: 'axis',
							backgroundColor: 'rgba(32, 33, 36,.7)',
							borderColor: 'rgba(32, 33, 36,0.20)',
							borderWidth: 1,
							textStyle: { // 文字提示样式
								color: '#fff',
								fontSize: '12'
							},
							axisPointer: { // 坐标轴虚线
								type: 'cross',
								label: {
									backgroundColor: '#6a7985'
								}
							}
						}
					};

					let columnData = [];
					let itemAmount = 0;
					for (let i = 0; i < response.data.length; i++) {
						columnData = [];
						for (let j = 0; j < columns.length; j++) {
							itemAmount = 0;
							for (let n = 0; n < response.data[i].operateTrendInfos.length; n++) {
								if (response.data[i].operateTrendInfos[n].businessDate == columns[j]) {
									itemAmount = response.data[i].operateTrendInfos[n].amount;
								}
							}
							columnData.push(itemAmount);
						}
						option.series.push({
							name: response.data[i].name,
							data: columnData,
							type: 'line'
						});
					}

					chartBox.setOption(option);
					// 根据页面大小自动响应图表大小
					window.addEventListener("resize", function() {
						chartBox.resize();
					});
				}).catch(function(error) {})
			},
			foldTotalDetailModalSearch() {
				this.totalDetailModalAdvancedSelect = false;
				this.searchItems.listType = '';
				this.searchItems.checkState = -1;
				this.searchItems.note = '';
			},
			initTotalDetailModalSearch() {
				this.searchItems.listCode = '';
				this.searchItems.userName = '';
				this.searchItems.businessPeopleName = '';
				this.searchItems.listType = '';
				this.searchItems.checkState = -1;
				this.searchItems.note = '';
			},
			initDebtList() {
				let self = this;
				request.get('/api/Home/GetDabtList', {
					params: {
						type: self.debtList
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取客户欠款数据失败：" + response.errorMsg
						});
						return;
					}
					self.debtAmount = 0;
					self.debtListData = response.data;
					for (var i = 0; i < response.data.length; i++) {
						self.debtAmount += response.data[i].debt;
					}
				}).catch(function(error) {})
			},
			initAlarmList() {
				let self = this;
				request.get('/api/Home/GetAlarmList', {
					params: {
						type: self.alarmList
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取商品报警数据失败：" + response.errorMsg
						});
						return;
					}
					self.alarmCount = response.data.length;
					self.alarmListData = response.data;
				}).catch(function(error) {})
			},
			clickTotalLists(type, index) {
				let self = this;
				self.searchItems.pageIndex = index;
				let url = '';
				switch (type) {
					case "销售金额":
						url = '/api/Home/GetTotalSalesLists';
						break;
					case "退货金额":
						url = '/api/Home/GetTotalSalesReturnLists';
						break;
					case "收款金额":
						url = '/api/Home/GetTotalReceiptLists';
						break;
					case "付款金额":
						url = '/api/Home/GetTotalPaymentLists';
						break;
					case "销售成本":
						url = '/api/Home/GetTotalSalesCostLists';
						break;
					case "销售利润":
						return;
					default:
						break;
				}
				request.post(url, self.searchItems).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取经营情况详情失败：" + response.errorMsg
						});
						return;
					}

					self.totalDetailModalTitle = type;
					self.totalDetailModalListData = response.data.lists;
					self.totalDetailModalListCount = response.data.count;
					self.totalDetailModal = true;
				}).catch(function(error) {})
			},
			getFlowListCount() {
				let self = this
				request.get('/api/Home/GetFlowListCount', {
					params: {
						userId: parseInt(localStorage.getItem("userId"))
					}
				}).then(function(result) {
					if (result.state != 1) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取待审核数据失败"
						});
						console.log("获取待审核数据失败：" + result.errorMsg)
						return
					}
					self.flowListCount = result.data
				}).catch(err => {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "获取待审核数据失败"
					});
					console.log("获取待审核数据失败：" + err.message)
				})
			},
			getUnpaidListCount() {
				let self = this
				request.get('/api/Home/GetUnpaidListCount', {
					params: {
						userId: parseInt(localStorage.getItem("userId"))
					}
				}).then(function(result) {
					if (result.state != 1) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取待付款数据失败"
						});
						console.log("获取待付款数据失败：" + result.errorMsg)
						return
					}
					self.unpaidListCount = result.data
				}).catch(err => {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "获取待付款数据失败"
					});
					console.log("获取待付款数据失败：" + err.message)
				})
			},
			getUncollectedListCount() {
				let self = this
				request.get('/api/Home/GetUncollectedListCount', {
					params: {
						userId: parseInt(localStorage.getItem("userId"))
					}
				}).then(function(result) {
					if (result.state != 1) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取待收款数据失败"
						});
						console.log("获取待收款数据失败：" + result.errorMsg)
						return
					}
					self.uncollectedListCount = result.data
				}).catch(err => {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "获取待收款数据失败"
					});
					console.log("获取待收款数据失败：" + err.message)
				})
			},
			goDetailPage(path) {
				this.$router.push({
					path: path
				});
			},
			initPermission() {
				let self = this;
				let params = {
					funcCodes: ['Home.Total', 'Home.Trend', 'Home.Debt', 'Home.Alarm','Home.StockAlarm','Home.OverdueAlarm','Home.Receivables'],
					userId: parseInt(localStorage.getItem("userId"))
				};
				request.post('/api/Function/VerifyPermissions', params).then(function(response) {
					let tipTimeoutCount = localStorage.getItem("_tipTimeoutCount")
					if(tipTimeoutCount != undefined){
						tipTimeoutCount = parseInt(tipTimeoutCount);
					}
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取权限数据失败：" + response.errorMsg
						});
						return;
					}else if(response.state == 2 && (tipTimeoutCount == undefined || tipTimeoutCount >= 1000)){
						self.$Modal.warning({
							title:'系统到期提示',
							content: response.errorMsg,
							onOk:() => {
								localStorage.setItem("_tipTimeoutCount",1)
							}
						});
					}
					if(tipTimeoutCount == undefined || tipTimeoutCount < 1000){
						localStorage.setItem("_tipTimeoutCount",tipTimeoutCount == undefined ? 1 : tipTimeoutCount+1)
					}
					for (var i = 0; i < response.data.length; i++) {
						switch (response.data[i].funcCode) {
							case 'Home.Total':
								self.permission.isTotal = response.data[i].permission
								break;
							case 'Home.Trend':
								self.permission.isTrend = response.data[i].permission
								break;
							case 'Home.Receivables':
								self.permission.isReceivables = response.data[i].permission
								if(!self.debtList){
									self.debtList = 'receipt'
								}
								break;
							case 'Home.Debt':
								self.permission.isDebt = response.data[i].permission
								if(!self.debtList){
									self.debtList = 'payment'
								}
								break;
							case 'Home.StockAlarm':
								self.permission.isStockAlarm = response.data[i].permission
								if(!self.alarmList){
									self.alarmList = 'stock'
								}
								break;
							case 'Home.OverdueAlarm':
								self.permission.isOverdueAlarm = response.data[i].permission
								if(!self.alarmList){
									self.alarmList = 'overdue'
								}
								break;
						}
					}
				}).catch(function(error) {})
			},
		},
		watch: {
			debtList() {
				this.initDebtList();
			},
			alarmList() {
				this.initAlarmList();
			}
		},
		created: function() {
			this.initPermission();
			this.getTotalOperate('昨日');
			setTimeout(() => {
				this.initTrendChart('本周');
			}, 200);
			this.getFlowListCount();
			this.getUnpaidListCount();
			this.getUncollectedListCount();
		}
	}
</script>

<style scoped>
	.home-container {
		padding-top: 2px;
	}

	.operateInfo {
		border-radius: 5px;
		background: #fff;
		margin-bottom: 10px;
	}

	.modal-title {
		overflow: hidden;
		padding: 10px;
		font-size: 16px;
	}

	.layout-title-left {
		float: left;
		display: flex;
		height: 32px;
		align-items: center;
		justify-content: center;
	}

	.layout-title-right {
		float: right;
	}

	.number-style {
		display: block;
		font-size: 30px;
		font-weight: 600;
		color: #000000;
		color: var(--font1Color);
		text-overflow: ellipsis;
		overflow: hidden;
		word-break: keep-all;
		white-space: nowrap;
	}
	
	.ivu-card{
		cursor: pointer;
	}
	
	.title-right-ul {
		overflow: hidden;
		font-size: 14px;
	}

	.title-right-ul li {
		float: left;
		margin-right: 10px;
		cursor: pointer;
	}

	.total-ul_selected {
		color: rgb(255, 77, 77);
		font-size: 16px;
	}

	#trendChart {
		min-width: 31.25rem;
		min-height: 31.25rem;
	}

	.trend-ul_selected {
		color: rgb(255, 77, 77);
		font-size: 16px;
	}

	.page-box {
		margin-top: 20px;
		text-align: center;
	}
	
	.card-box{
		padding:20px;
	}
	
	.modal-header{
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
</style>